import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import API from '@/app-core/api/Api'
import SelectStoreDialog from '@/app-theme/views/store/SelectStoreDialog.vue'
import CatalogProductListItem from '@/app-theme/components/store/CatalogProductListItem.vue'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'
import Translatable from '@/app-core/mixins/translatable'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import {getContrastColor} from '@/app-core/lib/utils/color'

export default {
  name      : 'Store',
  components: {
    CatalogProductListItem,
    SelectStoreDialog
  },
  directives: {},
  mixins    : [i18nRouteMeta, Translatable, StoreCommon],
  props     : {},
  enums     : {},
  dataStore : {
    AppCart  : 'App.Cart',
    AppTags  : 'App.Tags',
    AppStores: 'App.Stores',
    StoreMenu: 'Store.Menu',
    StoreInfo: 'Store.Info'
  },
  data() {
    return {
      title             : '',
      description       : '',
      store             : null,
      slug              : null,
      id                : null,
      isLoading         : false,
      storeDialogVisible: false
    }
  },
  computed: {
    storeMenuItems() {
      return this.StoreMenu[this.id]?.items || []
    }
  },
  watch: {
    '$route.params.id': {
      handler(val) {
        this.initView()
      },
      immediate: false
    }
  },
  beforeCreate() {
  },
  created() {
    this.$bus.$emit('cart:get-data')

    this.$bus.$on('show:select-store', this.showSelectStoreDialog)
    this.$bus.$on('store:selected', this.onStoreSelected)
    this.$bus.$on('store:init-menu', this.initView)
    this.$bus.$on('store:get-menu', this.getData)

    this.initView()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('show:select-store', this.showSelectStoreDialog)
    this.$bus.$off('store:selected', this.onStoreSelected)
    this.$bus.$off('store:init-menu', this.initView)
    this.$bus.$off('store:get-menu', this.getData)
  },
  destroyed() {
  },
  methods: {
    getContrastColor,
    toLocaleUpperCase,
    initView() {
      this.slug = this.$route.params?.slug
      this.id = this.$route.params?.id

      this.StoreInfo = this.AppStores?.find(store => parseInt(store.Id) === parseInt(this.id))
      this.title = this.StoreInfo.Name
      this.description = this.StoreInfo.Desc

      this.getData()
    },

    getData() {
      if (!this.id) return

      this.isLoading = true

      API.Resource.Store.Menu(this.id)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            data.items = this.fixDisabledMenuOptions(data.items)

            this.$set(this.StoreMenu, this.id, data)

            const storeId = API.responseData(response)?.store?.StoreId
            const store = this.getStoreById(storeId)
            if (store) store.Status = API.responseData(response)?.store
          } else {
            this.$set(this.StoreMenu, this.id, null)
          }
        })
        .catch(e => {
          this.StoreMenu[this.id] = null
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    fixDisabledMenuOptions(items) {
      const categories = items || []

      for (let c = 0; c < categories.length; c++) {
        const products = categories[c]?.Items || []

        for (let m = 0; m < products.length; m++) {
          const product = products[m]

          if (product.Active) {
            let options = product?.DetailsData?.Options || []

            if (!Array.isArray(options)) {
              options = Object.keys(options).map((k) => options[k])
            }

            for (let i = 0; i < options.length; i++) {
              const option = options[i]
              const optionIsRequired = option.Required && option.DisplayType === 'checkbox'
              const allOptionOptionValuesDisabled = option.OptionValues?.every(ov => ov.Disabled)
              if (allOptionOptionValuesDisabled) option.Disabled = true

              const optionIsDisabled = option.Disabled || allOptionOptionValuesDisabled

              if ((optionIsRequired && optionIsDisabled) || (option.DisplayType === 'radio' && optionIsDisabled)) {
                product.Status = false
                option.Disabled = true
                option.Required = false
              }

              if (option.Disabled) option.Required = false

              for (let ii = 0; ii < option.OptionValues.length; ii++) {
                const optionValue = option.OptionValues[ii]

                if (option.Disabled || optionValue.Disabled) {

                  if (option.DisplayType === 'radio') {
                    if (option.DefaultValueId?.toString() === optionValue.Id?.toString()) {
                      option.DefaultValueId = option.OptionValues.find(ov => !ov.Disabled)?.Id
                    }
                  }

                  if (option.DisplayType === 'checkbox') {
                    if (optionValue.Mandatory && optionValue.Selected) product.Status = false
                  }

                  optionValue.Selected = false
                  optionValue.Required = false
                }
              }
            }
          }
        }
      }

      return categories
    },

    showSelectStoreDialog() {
      this.storeDialogVisible = true
    },

    onStoreSelected(store) {
      if (!store || this.$route.params.id === store.Id) return

      this.$router.push({
        name  : 'Store',
        params: {
          slug: store.Slug,
          id  : store.Id
        }
      })
    },

    onScroll() {
      const offsetTop = 144

      const elements = [...this.$refs.container.children]
      elements.forEach(el => {
        const elementRect = el.getBoundingClientRect()
        if (elementRect.top < offsetTop) {
          this.$bus.$emit('category:select', el.id)
        }
      })
    }

  }
}
